/* eslint-disable */
import * as cheerio from 'cheerio';

Date.prototype.getWeek = function () {
	const onejan = new Date(this.getFullYear(), 0, 1);
	return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
};

export function createFileTree(xml, success) {
	let $;
	try {
		$ = cheerio.load(xml, { xmlMode: true, normalizeWhitespace: false });
		const fileTree = {};
		const treeItems = $('list').eq(0).children();
		treeItems.each(function () {
			const value = $(this).attr('name');
			const items = $(this).find('item');
			fileTree[value] = [];
			items.each(function () {
				fileTree[value].push([$(this).attr('name')]);
			});
		});
		success(fileTree);
	} catch (err) {}
}

const composerMatcher = function (message) {
	const matchTests = {
		composer: {
			regex: /com\.dealer\.cms\.apps\.composer\.(?:\w+\.)+(\w+)\.execute\(/,
			fn: match => match[1].replace(/([A-Z])/g, ' $1').trim(),
		},
		coreUtil: {
			regex: /com\.dealer\.cms\.tools\.CorePreferenceTool\.storeWindowPreference\(/,
			fn: () => 'Create Content',
		},
	};

	let matchString = '';

	Object.keys(matchTests).forEach((test) => {
		const match = message.match(matchTests[test].regex);
		if (match) {
			matchString = matchTests[test].fn(match);
		}
	});

	return matchString;
};

const cleanMessage = function (message) {
	// this is an attempt at turning java class messages into something a human might find useful
	const newMessage = {
		text: '',
		source: '',
	};

	const sourceRegex = /{([^{}]+)}$/;
	const sourceMatch = message.match(sourceRegex);

	const composerMatch = composerMatcher(message);

	if (composerMatch) {
		newMessage.source = 'Composer';
		newMessage.text = composerMatch;
	} else if (sourceMatch) {
		newMessage.text = message.replace(sourceRegex, '');
		newMessage.source = sourceMatch[1].toUpperCase();
	} else if(message.startsWith('WIC') || message.startsWith('WIBE')) {
		newMessage.text = message.substr(message.indexOf(" ") + 1);
		newMessage.source = message.split(" ")[0];
	} else {
		newMessage.text = message;
	}
	return newMessage;
};

const formatDate = function (dateString, now) {
	let seconds = Date.parse(dateString),
		D = new Date(seconds),
		months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
		date = {
			year: D.getFullYear(),
			dayNum: D.getDay(),
			day: days[D.getDay() - 1],
			date: D.getDate(),
			monthNum: D.getMonth() + 1,
			month: months[D.getMonth()],
			hours: D.getHours(),
			minutes: D.getMinutes(),
			seconds: D.getSeconds(),
			week: D.getWeek(),
			milliseconds: D.getTime()
		},
		makeTime = function () {
			let c = date.hours > 12 ? 'pm' : 'am',
				m = date.minutes < 10 ? '0' : '',
				s = date.seconds < 10 ? '0' : '',
				hour = date.hours > 12 ? date.hours - 12 : date.hours;
			return `${hour.toString()}:${m}${date.minutes.toString()}:${s}${date.seconds.toString()} ${c}`;
		},
		findGroups = function () {
			let matches = 'older';
			if (date.date === now.date && date.monthNum === now.monthNum && date.year === now.year) {
				matches = 'today';
			} else if (date.date === now.date - 1 && date.monthNum === now.monthNum && date.year === now.year) {
				matches = 'yesterday';
			} else if (date.week === now.week && date.year === now.year) {
				matches = 'thisWeek';
			} else if ((date.week === now.week - 1 && date.year === now.year) || (date.week === 52 && now.week === 1 && now.year === date.year + 1)) {
				matches = 'lastWeek';
			} else if (date.monthNum === now.monthNum && date.year === now.year) {
				matches = 'thisMonth';
			} else if ((date.monthNum === now.monthNum - 1 && date.year === now.year) || (date.monthNum === 12 && now.monthNum === 1 && now.year === date.year + 1)) {
				matches = 'lastMonth';
			} else if (date.year === now.year) {
				matches = 'thisYear';
			}
			return matches;
		},
		daysOld = function() {
			return (now.milliseconds - date.milliseconds) / 86400000;
		};
	date.time = makeTime();
	date.matches = findGroups();
	date.daysOld = daysOld();
	return date;
};

export function createRevisions(xml, success) {
	let $,
		N = new Date(Date.now()),
		now = {
			year: N.getFullYear(),
			date: N.getDate(),
			monthNum: N.getMonth() + 1,
			week: N.getWeek(),
            milliseconds: N.getTime()
		};
	try {
		$ = cheerio.load(xml, { xmlMode: true, normalizeWhitespace: false });
		const revisionsArray = [];
		const revisions = $('entries').children('entry');
		revisions.each(function () {
			const name = $(this).attr('commitedBy');
			const date = formatDate($(this).attr('date'), now);
			const id = parseInt($(this).attr('revision'), 10);
			const message = cleanMessage($('comment', this).text());
			const revEntry = {
				message: message.text,
				date,
				name,
				id,
				source: message.source,
			};
			revisionsArray.push(revEntry);
		});
		success(revisionsArray);
	} catch (err) {}
}

export function returnXML(xmlString, success) {
	success(xmlString);
}

export function formatXml(xmlString) {
	const xmlArray = xmlString.split('\n'),
		formatted = document.createElement('ol');

	for (const line in xmlArray) {
		// creates li out of every string in array
		let listItem = document.createElement('li');
		const node = document.createTextNode(xmlArray[line]),
			values = xmlArray[line].match(/'([^']+)'/g)
		;
		listItem.appendChild(node);

		if (values) {
			const newListItem = document.createElement('li');
			for (const value in values) {
				const start = xmlArray[line].indexOf(values[value]),
					span = document.createElement('span'),
					placeholderNode = document.createTextNode(values[value]);
				span.appendChild(placeholderNode);
				xmlArray[line] = xmlArray[line].replace(values[value], '');
				const str1 = xmlArray[line].substring(0, start),
					str2 = xmlArray[line].substring(start, xmlArray[line].length),
					str1Node = document.createTextNode(str1),
					str2Node = document.createTextNode(str2);

				newListItem.appendChild(str1Node);
				newListItem.appendChild(span);
				if (parseInt(value, 10) === values.length - 1) {
					newListItem.appendChild(str2Node);
				}
				xmlArray[line] = xmlArray[line].substring(start, xmlArray[line].length);
			}
			listItem = newListItem;
		}
		formatted.appendChild(listItem);
	}
	return formatted.outerHTML;
}

export function getSitecontentHTML(xmlString){
	if(xmlString.includes('sitecontent')){
        let $ = cheerio.load(xmlString, { xmlMode: true, normalizeWhitespace: false });
        let siteContentHtml = $('text').html();
        if(siteContentHtml){
            siteContentHtml = siteContentHtml.replace(new RegExp('&lt;', 'g'),'<').replace(new RegExp('&gt;', 'g'),'>').replace(new RegExp('&quot;', 'g'), '"').replace(new RegExp('/sites/', 'g'), 'https://static.dealer.com/sites/');
            let $content = cheerio.load(siteContentHtml, { xmlMode: true, normalizeWhitespace: false });
            $content('*').each(function () {
                $content(this).removeAttr('href');
            });
            return $content.html();
        } else {
        	return '';
		}
	} else {
		return '';
	}
}
